/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Popup_Settings_Showchart1Inputs */

const he_extension_popup_settings_showchart1 = /** @type {(inputs: Extension_Popup_Settings_Showchart1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הצג גרף מחירים`)
};

const en_extension_popup_settings_showchart1 = /** @type {(inputs: Extension_Popup_Settings_Showchart1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show price chart`)
};

/**
* | output |
* | --- |
* | "Show price chart" |
*
* @param {Extension_Popup_Settings_Showchart1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_popup_settings_showchart1 = /** @type {((inputs?: Extension_Popup_Settings_Showchart1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Popup_Settings_Showchart1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_popup_settings_showchart1(inputs)
	return en_extension_popup_settings_showchart1(inputs)
});
export { extension_popup_settings_showchart1 as "extension_popup_settings_showChart" }